import { Document, Page, PDFViewer, Text, View } from '@react-pdf/renderer';
import { useParams } from 'react-router-dom';

import { useGetContractQuery } from '@/apis/extended/contractApi';
import Appraisal from '@/components/Contract/Download/AppraisalContingency/Appraisal';
import Assignment from '@/components/Contract/Download/Assignment/Assignment';
import CashOfferComponent from '@/components/Contract/Download/CashOffer/CashOffer';
import Communication from '@/components/Contract/Download/Communication/communication';
import DateTime from '@/components/Contract/Download/DateTime/DateTime';
import EarnestMoneyComponent from '@/components/Contract/Download/EarnestMoney/EarnestMoneyComponent';
import FinancialStatus from '@/components/Contract/Download/FinancialStatus/FinancialStatus';
import FixturesandProperty from '@/components/Contract/Download/Fixture/FixtureandProperty';
import ForeignInvestment from '@/components/Contract/Download/ForeignInvestment/foreignInvestment';
import GoverningLaw from '@/components/Contract/Download/GoverningLaw/Governinglaw';
import HomeWarranties from '@/components/Contract/Download/HomeWarrantee/Homewarrantee';
import MaintenanceAndRisk from '@/components/Contract/Download/MaintenceandRisk/MaintenceandRisk';
import Mediation from '@/components/Contract/Download/Meditation/Meditation';
import NoticeAssesment from '@/components/Contract/Download/NoticeAssesment/NoticeAssesment';
import { PartiesInfo } from '@/components/Contract/Download/PartiesInfo/PartiesInfo';
import PlannedCommunity from '@/components/Contract/Download/PlannedCommunity/plannedCommunity';
import PostCloseOccupancy from '@/components/Contract/Download/PostCloseOccupancy/postCloseOccupancy';
import { PropertyInfo } from '@/components/Contract/Download/PropertyInfo/PropertyInfo';
import PurchasePrice from '@/components/Contract/Download/PurchasePrice/PurchasePrice';
import Recording from '@/components/Contract/Download/Recording/Recording';
import RecoveryFund from '@/components/Contract/Download/RecoveryFund/RecoveryFund';
import Release from '@/components/Contract/Download/Relase/Relase';
import Representation from '@/components/Contract/Download/Representation/Representation';
import SellerDisclosure from '@/components/Contract/Download/SellerDisclosure/SellerDisclosure';
import SettlementAndPossession from '@/components/Contract/Download/Settlement/Settlement and Posession';
import ContractState from '@/components/Contract/Download/State/choosestate';
import { styles } from '@/components/Contract/Download/style';
import Taxes from '@/components/Contract/Download/Taxes/taxes';
import Termination from '@/components/Contract/Download/Termination/termination';
import TitleandSurvey from '@/components/Contract/Download/TitleSurvey/TitleSurvey';
import UnbeatableClause from '@/components/Contract/Download/Unbeatable/UnbeatableClause';
import Zoning from '@/components/Contract/Download/Zoining/Zoining';
import { Contract } from '@/types/ContractType';
import HomeInspection from './HomeInspection/HomeInspection';
import Signature from './Signature/Signature';
import SpecialClause from './SpecialClause/specialclause';

const DownloadContractPage = () => {
  const { contractId } = useParams();
  if (!contractId) {
    return <div>No contract ID found</div>;
  }

  const { data: contract } = useGetContractQuery(contractId);

  const MyDocument = ({ contract }: { contract: Contract }) => (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.header}>REAL ESTATE PURCHASE CONTRACT</Text>
          <Text style={styles.contractId}>Contract ID: {contract?._id}</Text>
          <View style={styles.divider} />

          {/* Introduction */}
          <View style={styles.section}>
            <Text style={styles.text}>
              1. This Real Estate Purchase Contract ("Contract" or "Agreement")
              is made and entered into by and between{' '}
              {[contract?.buyerInfo?.name, contract?.buyerInfo?.name2]
                .filter(Boolean)
                .map((n) => n!.toUpperCase())
                .join(' and ') || 'Buyer'}{' '}
              ("Buyer") and{' '}
              {[contract?.sellerInfo?.name, contract?.sellerInfo?.name2]
                .filter(Boolean)
                .map((n) => n!.toUpperCase())
                .join(' and ') || 'Seller'}{' '}
              ("Seller").
            </Text>
            <Text style={styles.text}>
              2. The parties are referred to as Buyer and Seller throughout this
              Contract.
            </Text>
          </View>
          {/* Below is a description of what these contract={contract}? are  */}

          <PartiesInfo contract={contract} />
          <PropertyInfo contract={contract} />
          <PurchasePrice contract={contract} />
          <SettlementAndPossession contract={contract} />
          <DateTime contract={contract} />
          <Zoning contract={contract} />
          <FixturesandProperty contract={contract} />
          <TitleandSurvey contract={contract} />
          <NoticeAssesment contract={contract} />
          <Appraisal contract={contract} />
          <HomeInspection
            contract={contract}
            inspectionType={contract?.contingency?.inspectionType as any}
            inspectionContingency={
              contract?.contingency?.inspectionContingency as any
            }
          />
          <CashOfferComponent contract={contract} />
          <FinancialStatus />
          <EarnestMoneyComponent contract={contract} />
          <PostCloseOccupancy contract={contract} />
          <PlannedCommunity contract={contract} />
          <Taxes contract={contract} />
          <MaintenanceAndRisk contract={contract} />
          <HomeWarranties />
          <Recording />
          <Assignment />
          <GoverningLaw contract={contract} />
          <ForeignInvestment />
          <UnbeatableClause contract={contract} />
          <ContractState contract={contract} />
          <SellerDisclosure />
          <Termination contract={contract} />
          <Mediation />
          <Release />
          <RecoveryFund contract={contract} />
          <Communication />
          <Representation contract={contract} />
          <SpecialClause />
          <Signature contract={contract} />
        </View>
      </Page>
    </Document>
  );
  return (
    <div className="flex justify-center items-center h-screen">
      <PDFViewer width="100%" height="100%">
        <MyDocument contract={contract as Contract} />
      </PDFViewer>
    </div>
  );
};
export default DownloadContractPage;
